import { Graphics, Loader, Sprite } from "pixi.js"

export class IntroBackground extends Graphics {
    update = () => {
        const container = new Graphics()
        const sprite = new Sprite(Loader.shared.resources["intro_scene"].texture)
        sprite.scale.set(0.3)

        container.addChild(sprite)
        container.alpha = 0.0
        return container
    }
}
